import React from 'react';
import { Stack } from '@mui/material';
import ZoomControls from '@/components/FileViewer/Toolbar/ZoomControls';
import RotateButton from '@/components/FileViewer/Toolbar/RotateButton';
import ViewModeToggle from '@/components/FileViewer/Toolbar/ViewModeToggle';
import { ViewerSettings } from '@/types/fileViewer';

interface FloatingToolbarProps {
  settings: ViewerSettings;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onRotate: () => void;
  onToggleViewMode: () => void;
  isAiPanelOpen?: boolean;
  isMobile?: boolean;
  disableRotate?: boolean;
}

const FloatingToolbar: React.FC<FloatingToolbarProps> = ({
  settings,
  onZoomIn,
  onZoomOut,
  onRotate,
  onToggleViewMode,
  isAiPanelOpen = false,
  isMobile = false,
  disableRotate = false,
}) => {
  // AI 패널이 열려있고 PC일 때는 왼쪽으로 위치 조정 (패널 너비 400px 고정 고려)
  const leftPosition = !isMobile && isAiPanelOpen ? 'calc(50% - 200px)' : '50%';

  return (
    <Stack
      flexDirection={'row'}
      gap={'8px'}
      sx={{
        position: 'fixed',
        bottom: '32px',
        left: leftPosition,
        transform: 'translateX(-50%)',
        borderRadius: '12px',
        padding: '4px',
        display: 'flex',
        alignItems: 'center',
        boxShadow:
          '0 16px 16px 0 var(--effect-black-8, rgba(255, 255, 255, 0.08))',
        zIndex: 10,
        transition: 'left 0.3s ease',
        border: '1px solid var(--GrayScale-gray_3, #1F2327)',
        background: 'var(--GrayScale-gray_1, #16181B)',
      }}
    >
      {/* 줌 컨트롤 */}
      <ZoomControls
        zoom={settings.zoom}
        onZoomIn={onZoomIn}
        onZoomOut={onZoomOut}
      />

      {/* 회전 버튼 */}
      <RotateButton onRotate={onRotate} disabled={disableRotate} />

      {/* 뷰모드 토글 */}
      <ViewModeToggle
        // viewMode={settings.viewMode}
        onToggle={onToggleViewMode}
        isMobile={isMobile}
      />
    </Stack>
  );
};

export default FloatingToolbar;
